import FormControl, { FormError } from 'shared/components/FormControl/FormControl';
import UnwrappedInput from 'shared/components/Input';
import UnwrappedRangeInput from 'shared/components/RangeInput';

import UnwrappedRadio from 'design-system/components/Radio';
import UnwrappedTextArea, { TextAreaProps } from 'design-system/components/TextArea';

export default FormControl;
export { FormError };

export const Input = FormControl<React.InputHTMLAttributes<{}>>(UnwrappedInput);
export const Radio = FormControl(UnwrappedRadio);
export const RangeInput = FormControl(UnwrappedRangeInput);
export const TextArea = FormControl<TextAreaProps>(UnwrappedTextArea);
